<template>
    <div class="md-card">
        <div class="md-card-thumb">
            <img :src=thumb>
        </div>
        <div class="md-card-content">
            <div class="md-card-boby">
                <div class="md-card-title">
                    {{ title }}
                </div>
                <div class="md-card-desc">
                    {{ desc }}
                </div>
                <div class="md-card-tag">
                    <slot name="tags"></slot>
                </div>
            </div>
            <div class="md-card-footer">
                <div>
                    <span class="md-card-describe"> {{ describe }} </span>
                    <span class="md-card-price">
                        <slot name="price"></slot>
                    </span>
                </div>
                <slot name="btn"></slot>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'goodscard',
    props: {
        thumb: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        desc: {
            type: String,
            default: ""
        },
        btntitle: {
            type: String,
            default: ""
        },
        describe: {
            type: String,
            default: ""
        },


    },
}

</script>

<style scoped>
.md-card {
    display: flex;
    flex-direction: row;
    height: 2rem;
}

.md-card-thumb img {
    width: 2rem;
    height: 2rem;
}

.md-card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
}

.md-card-boby {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: 0.4rem;
}

.md-card-footer {
    font-size: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
}

.md-card-describe {
    font-size: 12px;
}

.md-card-price {
    font-size: 36px;
}

.md-card-title {
    font-size: 0.3rem;
}

.md-card-desc {
    font-size: 0.2rem;
    color: #969799;
}

.md-card-tag {
    display: flex;
    flex-direction: row;
}
</style>


// WEBPACK FOOTER //
// src/components/goodscard.vue